import { Fragment } from 'react';
import Modal from '@components/Modal';
import Spacer from '@components/Spacer';
import DocumentRow from './DocumentRow';
import s from './DocumentsListModal.module.scss';

type ThisCompiledDocument = Parameters<typeof DocumentRow>[0]['compiledDocument'] & {
  id: string;
  isNew?: true;
};
type ExternalCompledDocument = Omit<ThisCompiledDocument, 'isNew'>;

type Props = {
  compiledDocuments: Array<ExternalCompledDocument>;
  onClose: NonNullable<Parameters<typeof Modal>[0]['onClose']>;
};

const DocumentsListViewModal: React.FC<Props> = ({ compiledDocuments, onClose }) => (
  <Modal
    title={'Documents'}
    onClose={onClose}
    hasForm={false}
  >
    <div className={s['compiled-documents-modal-content']}>
      {compiledDocuments.map(compiledDocument => (
        <Fragment key={compiledDocument.id}>
          <DocumentRow
            compiledDocument={compiledDocument}
          />
          <Spacer size={24} />
        </Fragment>
      ))}
    </div>
  </Modal>
);

export default DocumentsListViewModal;
